// 引用 vue 没什么要说的
import Vue from 'vue'
// 引用路由
import VueRouter from 'vue-router'
// 光引用不成，还得使用
Vue.use(VueRouter)

import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard)


// 入口文件为 src/App.vue 文件 所以要引用
import App from './App.vue'
// 引用路由配置文件
import routes from './config/routes'
// 引用scss
import '../static/style/css/style.scss'
// 引用js
import "babel-polyfill"
import '../static/js/util.js'
//引用install好的插件
import axios from 'axios'
Vue.prototype.$ajax = axios

import hotcss from 'hotcss'

// 创建路由对象
const router = new VueRouter({
	// mode: 'history',
	routes		//（缩写）相当于 routes: routes，es6的新语法
})
Vue.directive('title', {
  inserted: function (el, binding) {
    document.title = binding.value
  }
})
// 跑起来吧
new Vue({
	router,
	el: '#app',
	render: (h) => h(App)
})


// WEBPACK FOOTER //
// ./src/main.js